import React, { Component } from "react";
import AnalyticsDispatcher from "dispatchers/analytics-dispatcher";
import { connect } from "react-redux";
import ClickContributionCard from "visual-components/analytics/campaign/click-contribution-card";

class ClickContribution extends Component {
  updateBrand = (brandId) => {
    const data = {
      metric: "campaignCustomCTA",
      campaignId: this.props.campaignId,
      specificBrandId: brandId,
    };

    AnalyticsDispatcher.fetchReport(data, "analyticsCampaign");
  };

  render() {
    const { data, started, isHost, isSolo, className = "" } = this.props;

    return (
      <ClickContributionCard
        {...data}
        started={started}
        isHost={isHost}
        isSolo={isSolo}
        onChange={this.updateBrand}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.analyticsCampaign.campaignCustomCTA,
    campaignId: state.analyticsCampaign.campaign.id,
    isHost: state.analyticsCampaign.isHost,
    isSolo: state.analyticsCampaign.campaign.isSolo,
  };
};

export default connect(mapStateToProps)(ClickContribution);
